module.exports = function getMediaDownloadPath(media) {
	let external = false;
	let url;
	if (
		media.attributes &&
		!!media.attributes.field_external_url &&
		media.attributes.field_external_url.uri
	) {
		url = media.attributes.field_external_url.uri;
		external = true;
	} else if (process.env.GATSBY_DIRECT_MEDIA_DOWNLOAD) {
		url =
			media.attributes && media.attributes.drupal_internal__mid
				? `${process.env.GATSBY_BACKEND_URL}/media/${media.attributes.drupal_internal__mid}`
				: `/download?media=${media.id}`;
	} else {
		url = `/download?media=${media.id}`;
	}
	return { uri: url, external };
};
